import { render, staticRenderFns } from "./Quotes.vue?vue&type=template&id=51f0deda&"
import script from "./Quotes.vue?vue&type=script&lang=js&"
export * from "./Quotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports